import { restApiRequestPost, getErrorMessage } from './ajax'

const agency = {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    /**
     * 代理店一覧を取得する
     * @param {*} params
     */
    getAgencyList: function({ commit }, params) {
      return new Promise((resolve, reject) => {
        const baseURL = process.env.BaseURL
        // 初期リリースでは広告主は固定
        restApiRequestPost(baseURL, `/api/agent/list/${params.privateCode}/0/${params.deliveryMonth}`, params.jwtToken, params)
          .then(result => {
            if (result.status === 200) {
              resolve(parse(result))
            } else {
              reject(new Error('Irregular Error.'))
            }
          })
          .catch(err => {
            if (!err) {
              resolve(undefined)
              return
            } else if (!err.response) {
              reject(new ReferenceError('commons.restapi.system.error'))
              return
            } else if (err.response.data.errorCode === 'permission.expiration.error') {
              reject(new Error(getErrorMessage(err.response.data.errorCode)))
              return
            }
            reject(new ReferenceError(getErrorMessage(err.response.data.errorCode)))
          })
      })
    }
  }
}

function parse(response) {
  return response.data
}

export default agency
